<div class="relative isolate flex min-h-svh w-full max-lg:flex-col">
    <main class="hidden lg:flex flex-1 flex-col p-2 lg:min-w-0 w-full">
        <div
            class="grow overflow-hidden relative lg:rounded-lg lg:bg-white dark:bg-zinc-950 px-6 lg:px-10 lg:py-16 lg:shadow-sm lg:ring-1 lg:ring-zinc-950/10 dark:lg:ring-white/10">
            <div class="absolute inset-0">
                <img src="assets/images/branding/cover-image.png" class="size-full object-cover" alt="" />
            </div>
        </div>
    </main>
    <div
        class="min-h-full lg:w-1/2 flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div class="mx-auto w-full max-w-sm lg:max-w-lg">
            <div>
                <img class="h-16 w-auto object-scale-down" src="assets/images/branding/logo-login.png" alt="company" />
                <h2 class="mt-8 heading">
                    Create your account
                </h2>
                <p class="mt-1 text-sm-light">
                    Fill in the details below to get started.
                </p>
            </div>
            <div>
                <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
                    <section class="grid gap-4 sm:grid-cols-2">
                        <div class="space-y-1">
                            <label class="subheading">
                                First Name <span class="text-red-600">*</span>
                            </label>
                            <div>
                                <div>
                                    <input formControlName="firstName" type="text" [readonly]="(user?.firstName || user?.given_name) || false" />
                                </div>
                                <div *ngIf="submitted && form.firstName.errors">
                                    <p *ngIf="form.firstName.errors.required" class="pt-1 text-red-600 text-xs">
                                        First Name is required
                                    </p>
                                </div>
                            </div>
                        </div>



                        <div class="space-y-1">
                            <label class="subheading">
                                Last Name <span class="text-red-600">*</span>
                            </label>
                            <div>
                                <div>
                                    <input formControlName="lastName" type="text" placeholder="" [readonly]="(user?.lastName || user?.family_name) || false" />
                                </div>
                                <div *ngIf="submitted && form.lastName.errors">
                                    <p *ngIf="form.lastName.errors.required" class="pt-1 text-red-600 text-xs">
                                        Last Name is required
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="space-y-1">
                            <label class="subheading">
                                Contact Number <span class="text-red-600">*</span>
                            </label>
                            <div>
                                <div>
                                    <input formControlName="contactNumber" maxlength="11" type="text" />
                                </div>
                                <div *ngIf="submitted && form.contactNumber.errors">
                                    <p *ngIf="registerForm.get('contactNumber')?.errors?.required"
                                        class="pt-1 text-red-600 text-xs">
                                        Contact Number is required
                                    </p>
                                    <p *ngIf="submitted && (registerForm.get('contactNumber')?.errors?.minlength || registerForm.get('contactNumber')?.errors?.maxlength)"
                                        class="pt-1 text-red-600 text-xs">
                                        Minimum 10 digits are required and maximum 11 digits are allowed
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="space-y-1">
                            <label class="subheading">
                                Email <span class="text-red-600">*</span>
                            </label>
                            <div>
                                <div>
                                    <input formControlName="email" type="text"  [readonly]="user?.email || false"/>
                                </div>
                                <div *ngIf="submitted && form.email.errors">
                                    <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                                        Email is required
                                    </p>
                                    <div *ngIf="form.email.errors.email" class="error">
                                        <p class="mt-2 text-xs text-red-500" id="title-description">
                                            Invalid Email format
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ng-container formGroupName="address">
                            <div class="space-y-1 col-span-full">
                                <label class="subheading">
                                    Address <span class="text-red-600">*</span>
                                </label>
                                <div>
                                    <input googlePlace (onSelect)="onSelectAddress($event)" formControlName="name"
                                        type="text" (input)="onChangeAddress()"  />
                                    <div *ngIf="submitted" class="error">
                                      
                                        <p *ngIf="addressForm?.errors?.invalidAddress"
                                            class="mt-2 text-red-600 text-xs">
                                            Invalid address (select from the dropdown)
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </ng-container>

                        <!-- <div class="space-y-1">
                            <label class="subheading">Time Zone</label>
                            <div>
                                <select formControlName="timeZone">
                                    <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
                                </select>
                                <div *ngIf="submitted && form.timeZone.errors">
                                    <p *ngIf="form.timeZone.errors.required" class="pt-1 text-red-600 text-xs">
                                        Time Zone is required
                                    </p>
                                </div>
                            </div>
                        </div> -->
    
                        <!-- Password -->
                         <ng-container *ngIf="!provider">
                             <div class="space-y-1">
                            <label class="subheading">Password</label>
                            <div class="flex flex-1 gap-2 items-center">
                                <div class="flex-1 relative">
                                    <input formControlName="password" [type]="showPassword ? 'text' : 'password'"
                                        class="input-class w-full pr-10" />
                                    <span
                                        class="absolute inset-y-0 right-2 flex items-center cursor-pointer text-gray-500"
                                        (click)="toggleVisibility('password')">
                                        <ng-container *ngIf="showPassword; else hideIcon">
                                            <!-- Eye Slash Icon (Hide Password) -->
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="size-6">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                                            </svg>
                                        </ng-container>
                                        <ng-template #hideIcon>
                                            <!-- Eye Icon (Show Password) -->
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="size-6">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>
                                        </ng-template>
                                    </span>
                                </div>
                            </div>

                            <div *ngIf="form.password?.errors && submitted">
                                <div *ngIf="form.password?.errors?.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">Password is required</p>
                                </div>
                                <div *ngIf="form.password?.errors?.minlength" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Password must be at least 8 characters with letters & numbers
                                    </p>
                                </div>
                                 <div *ngIf="form.password?.errors?.passwordStrength" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                    Password must includes letters and numbers

                                    </p>
                                </div>

                            </div>



                        </div>
                        <div class="space-y-1">
                            <label class="subheading">Confirm Password</label>
                            <div class="flex flex-1 gap-2 items-center">
                                <div class="flex-1 relative">
                                    <input formControlName="confirmPassword"
                                        [type]="showConfirmPassword ? 'text' : 'password'"
                                        class="input-class w-full pr-10" />
                                    <span
                                        class="absolute inset-y-0 right-2 flex items-center cursor-pointer text-gray-500"
                                        (click)="toggleVisibility('confirmPassword')">
                                        <ng-container *ngIf="showConfirmPassword; else hideIcon">
                                            <!-- Eye Slash Icon (Hide Password) -->
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="size-6">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                                            </svg>
                                        </ng-container>
                                        <ng-template #hideIcon>
                                            <!-- Eye Icon (Show Password) -->
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="size-6">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>
                                        </ng-template>
                                    </span>
                                </div>
                            </div>
                            
                            <!-- Confirm Password field errors -->
                            <div *ngIf="submitted && form.confirmPassword?.errors">
                            
                                <div *ngIf="form.confirmPassword.errors?.required">
                                    <p class="mt-2 text-red-600 text-xs">Confirm Password is required</p>
                                </div>
                            
                                <div *ngIf="form.confirmPassword.errors?.minlength">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Confirm Password must be at least 8 characters
                                    </p>
                                </div>
                            
                            </div>
                            
                            <!-- Password mismatch error -->
                            <div *ngIf="submitted && registerForm.errors?.passwordMismatch && form.confirmPassword?.touched">
                                <p class="text-red-500 text-xs">
                                    Passwords do not match
                                </p>
                            </div>



                        </div>
                         </ng-container>
                       


                    </section>
                    <!-- <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" /> -->
                  <button type="submit" class="mt-8 btn btn-primary w-full">
                        Signup
                        <span class="flex flex-inline items-center" *ngIf="provider==='apple'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="size-6 mr-1" viewBox="0 0 24 24">
                                <path fill="currentColor"
                                    d="M17.05 20.28c-.98.95-2.05.8-3.08.35c-1.09-.46-2.09-.48-3.24 0c-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8c1.18-.24 2.31-.93 3.57-.84c1.51.12 2.65.72 3.4 1.8c-3.12 1.87-2.38 5.98.48 7.13c-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25c.29 2.58-2.34 4.5-3.74 4.25" />
                            </svg>
                            with Apple
                        </span>
                    
                        <span class="flex flex-inline  items-center" *ngIf="provider==='google'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="size-6 mr-1" viewBox="0 0 48 48">
                                <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 
                          11-11c2.8 0 5.3 1 7.3 2.7l5.7-5.7C33.5 6.5 28.9 4.5 24 4.5C12.9 4.5 4 13.4 4 24.5S12.9 44.5 
                          24 44.5c11 0 20-8 20-20c0-1.3-.1-2.7-.4-4z" />
                                <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16.1 18.9 13 24 13c2.8 0 5.3 1 7.3 
                          2.7l5.7-5.7C33.5 6.5 28.9 4.5 24 4.5c-7.7 0-14.3 4.4-17.7 10.2z" />
                                <path fill="#4CAF50" d="M24 44.5c5.2 0 9.9-2 13.5-5.2l-6.2-5.1C29.4 35.5 26.8 36.5 24 
                          36.5c-5.3 0-9.7-3.6-11.3-8.5l-6.5 5C9.7 40.1 16.3 44.5 24 44.5z" />
                                <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-1.1 3.1-3.5 5.5-6.7 
                          6.7l6.2 5.1C39.5 36.3 44 30.9 44 24.5c0-1.3-.1-2.7-.4-4z" />
                            </svg>
                            with Google
                        </span>
                    </button>
                </form>
                <p class="mt-3 text-center text-sm-light">
                    Already have an account?
                    <a routerLink="/login" class="text-sm-light font-medium hover:text-[#209fbc] hover:underline">
                        Sign in
                    </a>
            </div>
        </div>
    </div>
</div>